import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';

import DraggableButton from './DraggableButton';
import styles from './AdminCollapsibleContainer.module.css';

const DeleteButton = ({ deleteAction }) => (
  <button
    className={`naked-button ${styles.deleteButton}`}
    type="button"
    onClick={deleteAction}
  >
    <i className="fal fa-trash-alt" />
  </button>
);

DeleteButton.propTypes = {
  deleteAction: PropTypes.func.isRequired,
};

const AdminCollapsibleContainer = ({
  title,
  children,
  draggable,
  deleteAction,
}) => {
  const [containerOpen, setContainerOpen] = useState(true);
  const containerClassName = classNames(styles.container, {
    'draggable-container': draggable,
    [styles.draggableContainer]: draggable,
  });
  const contentClassName = classNames(styles.content, {
    [styles.hidden]: !containerOpen,
  });
  const toggleIconClassName = containerOpen
    ? 'far fa-chevron-down'
    : 'far fa-chevron-right';
  const toggleContainerOpen = () => setContainerOpen((prevState) => !prevState);

  return (
    <>
      <div className={containerClassName}>
        <div className={styles.header}>
          {draggable && <DraggableButton containerOpen={containerOpen} />}
          <button
            className={styles.toggle}
            type="button"
            onClick={toggleContainerOpen}
          >
            <p style={draggable ? null : { marginLeft: '18px' }}>{title}</p>
            <i className={toggleIconClassName} />
          </button>
          {deleteAction && <DeleteButton deleteAction={deleteAction} />}
        </div>
        <div className={contentClassName}>{children}</div>
      </div>
      {draggable && (
        <ReactTooltip
          id="draggable-button"
          place="top"
          type="dark"
          effect="solid"
          className={styles.tooltip}
        />
      )}
    </>
  );
};

AdminCollapsibleContainer.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  draggable: PropTypes.bool,
  deleteAction: PropTypes.func,
};

AdminCollapsibleContainer.defaultProps = {
  draggable: false,
  deleteAction: () => {},
};

export default AdminCollapsibleContainer;
